import React from 'react';
import { useT } from '../i18n';

export function LangSwitch({ dark = false, className = '' }) {
  const { lang, setLang } = useT();
  return (
    <div className={`flex items-center rounded-full border overflow-hidden text-[11px] font-bold ${dark ? 'border-white/20' : 'border-gray-200'} ${className}`} data-testid="lang-switch">
      {['en', 'es'].map((l) => (
        <button key={l} type="button" onClick={() => setLang(l)} data-testid={`lang-${l}`} aria-label={l === 'en' ? 'English' : 'Español'}
          className={`px-2.5 py-1 uppercase tracking-wide transition-colors ${lang === l
            ? 'bg-[#F77F11] text-white'
            : dark ? 'text-white/50 hover:text-white' : 'text-gray-400 hover:text-gray-700'}`}>
          {l}
        </button>
      ))}
    </div>
  );
}
